import client from "./client";

const EntryTypeService = {};

EntryTypeService.get = function () {
  return client.get(`/entryType`);
};

EntryTypeService.update = function (entryTypeId, data) {
  return client.put(`/entryType/${entryTypeId}`, data);
};

EntryTypeService.create = function (data) {
  return client.post(`/entryType`, data);
};

EntryTypeService.delete = function (entryTypeId) {
  return client.del(`/entryType/${entryTypeId}`);
};

export default EntryTypeService;
